import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetAuditLog } from "../../utils/GetSecurity";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    primary: {
      marginTop: theme.spacing(2),
    },
  })
);
export default function SecAdminAudit() {
  const classes = useStyles();
  const [auditLog, SetAuditLog] = useState<any[]>([]);
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'security_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});

  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:250;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })

  useEffect(() => {
    if (doneLoading) return;
    GetAuditLog(salesOrg).then((v) => {
      setDoneLoading(true);
      if(v){
        SetAuditLog(v.logAuthAudit);
      }
    });
  }, [auditLog, doneLoading, salesOrg]);
  return (
    <div className={classes.root}>
      {doneLoading && enabled? (
        <div>
            <TableAbstraction
            settingsKey="ADM_SAA"
              options={{
                draggableColumns: {
                  enabled: true,
                },
                rowsPerPageOptions: [25, 50, 100],
                tableBodyHeight: TABLE_BODY_HEIGHT,
                serverSide: false,
                selectableRows: "none",
                rowsPerPage: muiTable.rpp,
                onChangeRowsPerPage: (numberOfRows) => {
                  muiTable.rpp = numberOfRows;
                  setMuiTable(muiTable);
                },
              }}
              title="Audit Log"
              columns={[
                {
                  label: "User Name",
                  name: "userName",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
                {
                  label: "Method",
                  name: "requestMethod",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
                {
                  label: "Base URL",
                  name: "requestBaseUrl",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
                {
                  label: "Path",
                  name: "requestPath",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
                {
                  label: "Params",
                  name: "requestParams",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
                {
                  label: "Query",
                  name: "requestQuery",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
                {
                  label: "Time Stamp",
                  name: "actionDt",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
              ]}
              data={auditLog}
            />
        </div>
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Security Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
    </div>
  );
}